/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".chrome-message[_ngcontent-%COMP%]{font-size:16pt;text-align:center;color:#000;background-color:#badaf3;padding:15px;margin:10px}.chrome-message-subtle[_ngcontent-%COMP%]{font-size:10pt;text-align:center;color:#616060;background-color:#badaf3;padding:15px;margin:10px 1px}"];
export { styles as styles };
